import React, { Component } from 'react'
import { CheckOutlined } from '@ant-design/icons'
import { Modal, Button } from 'hljd'
import Style from './style.module.less'
import { MATERIAL_PATH_A } from '@constant'

class AddMaterial extends Component {
  constructor(props) {
    super(props)
    this.state = {
      check_list: [],
      visibility: false
    }
  }

  static defaultProps = {
    title: '添加素材',
    goMaterialStore: false,
    footer: undefined,
    extra: '',
    key: 'id'
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (
      nextProps.visibility &&
      !prevState.visibility &&
      nextProps.list &&
      nextProps.checkList
    ) {
      return {
        check_list: nextProps.list.filter(
          item => nextProps.checkList.indexOf(item[nextProps.key]) > -1
        ),
        visibility: true
      }
    } else if (!nextProps.visibility) {
      return {
        check_list: [],
        visibility: false
      }
    } else {
      return null
    }
  }

  handleModalOk = () => {
    console.log(this.state.check_list)
    const { onOk } = this.props
    onOk && onOk(this.state.check_list)
  }

  closeCaseModal = () => {
    const { onCancel } = this.props
    onCancel && onCancel(this.state.check_list)
  }

  toLink = () => {
    this.closeCaseModal()
    window.location.href = MATERIAL_PATH_A
  }

  toAddMaterial = type => () => {
    this.closeCaseModal()
    window.location.href = `${MATERIAL_PATH_A}?type=${type}`
  }

  renderFooter = () => {
    const { extra, footer, goMaterialType } = this.props
    if (footer) {
      return footer(this.handleModalOk, this.closeCaseModal)
    } else if (goMaterialType) {
      return (
        <div>
          <Button type="primary" onClick={this.toAddMaterial(goMaterialType)}>
            添加素材
          </Button>
          <Button onClick={this.toLink}>创意中心</Button>
          <Button type="primary" onClick={this.handleModalOk}>
            保存
          </Button>
        </div>
      )
    }
    return (
      <div className={Style.footer}>
        {extra}
        <div>
          <Button className={Style.btn} onClick={this.closeCaseModal}>
            取消
          </Button>
          <Button
            className={Style.btn}
            type="primary"
            onClick={this.handleModalOk}
          >
            确定
          </Button>
        </div>
      </div>
    )
  }

  renderEmpty = () => {
    const { emptyEle } = this.props
    if (emptyEle) {
      return emptyEle
    } else {
      return (
        <div className={Style['hlj-add-material-empty']}>
          <div className={Style['empty-content']}>
            您还没有添加对应素材，请先添加素材再来哦！
          </div>
        </div>
      )
    }
  }

  checkItem = item => () => {
    const { key, onCheck } = this.props
    let _list = [...this.state.check_list]
    onCheck && onCheck(item, _list)
    const _index = _list.findIndex(val => val[key] === item[key])
    if (_index === -1) {
      _list.push(item)
    } else {
      _list.splice(_index, 1)
    }
    this.setState({
      check_list: _list
    })
    console.log(_list)
  }

  render() {
    const {
      Item,
      width,
      height,
      title,
      checkedIcon,
      list,
      key,
      wrapStyle
    } = this.props

    const { check_list, visibility } = this.state

    return (
      <Modal
        title={title}
        visible={visibility}
        width={width ? width : 752}
        height={height ? height : 507}
        onCancel={this.closeCaseModal}
        footer={this.renderFooter()}
      >
        <div className={Style.libraryArea}>
          {list.length ? (
            list.map((el, i) => {
              const checked =
                check_list.findIndex(item => item[key] === el[key]) !== -1
              return (
                <div
                  key={i}
                  onClick={this.checkItem(el)}
                  className={
                    checked
                      ? `${Style['hlj-add-material-checked']} ${
                          Style['hlj-add-material-wrapper']
                        }`
                      : Style['hlj-add-material-wrapper']
                  }
                  style={wrapStyle}
                >
                  <Item
                    key={i}
                    item={el}
                    checked={checked}
                    onChange={this.checkItem}
                  />
                  {checkedIcon ? (
                    checkedIcon(checked)
                  ) : (
                    <span className={Style['check-icon']}>
                      <span className={Style['back']} />
                      <span className={Style['icon']}>
                        <CheckOutlined />
                      </span>
                    </span>
                  )}
                </div>
              )
            })
          ) : (
            <div>{this.renderEmpty()}</div>
          )}
        </div>
      </Modal>
    )
  }
}

export default AddMaterial
